import i18n, { i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources";

export const DEFAULT_LANGUAGE = "en-GB";

export const SUPPORTED_LANGUAGES = ["en-GB", "en-US"] as const;

/**
 * Create and configure a standalone react-i18next instance seeded with the
 * supplied language (falling back to British English).
 *
 * @param language - The active language code, e.g. "en-GB" or "en-US".
 * @returns A configured i18next instance bound to react-i18next.
 */
export const createi18nInstance = (
  language: string = DEFAULT_LANGUAGE
): I18nInstance => {
  const instance = i18n.createInstance();

  void instance.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    // Resources are pre-bundled, so initialise synchronously and guarantee
    // t() returns translations rather than keys on the first render.
    initAsync: false,
    interpolation: {
      escapeValue: false
    }
  });

  return instance;
};

/**
 * Shared instance used to bootstrap i18n at app startup. The active language
 * is kept in sync with the user's `language` preference.
 */
export const i18nInstance = createi18nInstance();
